const serializer = {};

serializer.serialize = function(model, payload) {
  return new Promise(resolve => {
    const result = this.serializeresource(model, payload);
    resolve(result);
  });
};

serializer.serializeresource = function(model, payload) {
  let serialized = {};

  Object.keys(model.fields())
    .filter(key => payload[key])
    .forEach(key => {
      serialized[this.toSnakeCase(key)] = payload[key];
    });

  Object.keys(model.fields())
    .filter(key => typeof payload[key] === 'boolean')
    .forEach(key => {
      if (serialized[this.toSnakeCase(key)] === undefined) {
        serialized[this.toSnakeCase(key)] = false;
      }
    });

  Object.keys(model.fields())
    .filter(key => key.indexOf('_collection') > -1)
    .forEach(key => {
      serialized[key.replace('_collection', '')] = payload[key];
    });

  if (model.autoSerialize) {
    model.autoSerialize.forEach(item => {
      serialized[item.convertTo] = payload[item.key];
    });
  }

  Object.keys(serialized).forEach(key => {
    if (
      (key.indexOf('_url') > -1 && key !== 'avatar_url') ||
      key.indexOf('_id') > -1
    ) {
      delete serialized[key];
    }
  });

  return serialized;
};

serializer.toSnakeCase = function(key) {
  return key.replace(/([A-Z])/g, '_$1').toLowerCase();
};

export default serializer;
